import styled, { css } from 'styled-components'

export const Container = styled.div`
    height: inherit;
    width: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${props => (props.bgColor ? props.bgColor : 'none')};

    ${props =>
        props.overlay &&
        css`
            position: absolute;
            width: 100vw;
            height: 100vh;
            z-index: 9999;
        `}

    /* handheld devices (tabs, phones, 768px and down) */
    @media only screen and (max-width: 768px) and (orientation: portrait) {
        font-size: 6vw;
    }

    /* handheld devices (ipads, tabs, phones, 1024px and down) */
    @media only screen and (max-width: 1024px) and (orientation: landscape) {
        font-size: 5vw;
    }
`

export const BouncingLogo = styled.div`
    height: 80px;
    width: 80px;
    background: url('/img/oh-logo.svg') center no-repeat;
    background-size: contain;
    background-color: transparent;

    animation: bounce 0.3 infinite alternate;
    -webkit-animation: bounce 0.3s infinite alternate;

    @keyframes bounce {
        from {
            transform: scale(0.9);
        }
        to {
            transform: scale(1.2);
        }
    }
    @-webkit-keyframes bounce {
        from {
            transform: scale(0.9);
        }
        to {
            transform: scale(1.2);
        }
    }
`
